import React, { type ReactNode } from 'react';
import type { SieveFilterModel } from '~/util/sieve/filter';

interface DataTableFilterInjectContextProviderProps {
	defaultFilters?: SieveFilterModel[];
	children: React.ReactNode;
}

interface DataTableFilterInjectContextValue {
	defaultFilters?: SieveFilterModel[];
}

const DataTableFilterInjectContext = React.createContext<DataTableFilterInjectContextValue | null>(null);

export function DataTableFilterInjectContextProvider({ defaultFilters = [], children }: DataTableFilterInjectContextProviderProps): ReactNode {
	return <DataTableFilterInjectContext.Provider value={{ defaultFilters }}>{children}</DataTableFilterInjectContext.Provider>;
}

export function useDataTableFilterInjectContext(): DataTableFilterInjectContextValue | null {
	return React.useContext(DataTableFilterInjectContext as React.Context<DataTableFilterInjectContextValue | null>);
}
